import { render } from "./VisionDataView.vue?vue&type=template&id=598d9530&scoped=true"
import script from "./VisionDataView.vue?vue&type=script&lang=js"
export * from "./VisionDataView.vue?vue&type=script&lang=js"

import "./VisionDataView.vue?vue&type=style&index=0&id=598d9530&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598d9530"]])

export default __exports__